import React, { useMemo } from "react";
import ProjectItem from "components/uiComponents/ProjectItem";

const ProjectNavList = ({
  list,
  treeAction,
  searchValue,
  level,
}) => {
  const memoList = useMemo(
    () =>
      list &&
      list.map((el) => (
        <ProjectItem
          item={el}
          key={el.id}
          treeAction={treeAction}
          searchValue={searchValue}
          level={level}
        />
      )),
    [list, searchValue]
  );
  return <div className={`folder-list`}>{memoList}</div>;
};

export default ProjectNavList;
